export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $pinia } = useNuxtApp();
  // const staticExtensions = ['.png', '.svg', '.jpg', '.jpeg', '.gif', '.webp', '.ico', '.webmanifest', '.json', '.txt'];
  // if (staticExtensions.some(ext => to.path.toLowerCase().endsWith(ext))) return;
  const storesInitialized = useState('storesInitialized', () => false);
  if (storesInitialized.value) return;

  // Handle intranet auth before fetching site data
  // - Auth pages don't need site data
  // - When not logged in, redirect to login page
  const { isIntranet, useIntranetLogin, goToLoginPageFrontendIntranet, setReturnUrl } = useIntranetAuth();
  if (isIntranet() && useIntranetLogin()) {
    if (to.path.startsWith('/auth/intranet/')) {
      return;
    }
    const authIntranet = useAuthIntranetStore();
    authIntranet.clearIfExpired();
    if (!authIntranet.isLoggedInIntranet) {
      if (to.path !== '/' && !to.path.startsWith('/.well-known/')) {
        setReturnUrl(to.path);
      }
      return navigateTo(goToLoginPageFrontendIntranet(), { replace: true });
    }
  }

  const getHostName = () => {
    try {
      return useRequestURL().hostname
    } catch {
      return typeof window !== 'undefined' ? window.location.hostname : null
    }
  }

  const hostname = getHostName()
  let website: any

  if (hostname) {
    try {
      website = await useSiteRepository(hostname, to)
    } catch (err: any) {
      if (err?.statusCode === 401 && isIntranet() && useIntranetLogin()) {
        useAuthIntranetStore().clearLoginData();
        if (to.path !== '/' && !to.path.startsWith('/.well-known/')) {
          setReturnUrl(to.path);
        }
        return navigateTo(goToLoginPageFrontendIntranet(), { replace: true });
      }
      throw err;
    }
  }

  const dataAll = useDataAll($pinia);

  if (website != null) {
    if (!website.siteJson && !website.WebPages && !website.NewsOverview) {
      dataAll.setLoadedSuccessfully(false);
      throw createError({ statusCode: 500, statusMessage: 'No data returned from API for hostname: ' + hostname })
    }

    useSiteSettingsStore($pinia).populate(website.siteJson || []);
    usePageOverviewStore($pinia).populate(website.WebPages || []);
    useNewsOverviewStore($pinia).populate(website.NewsOverview || []);
    useEventOverviewStore($pinia).populate(website.EventOverview || []);
    useRedirectStore($pinia).populate(website.Redirects || []);
    storesInitialized.value = true;
    dataAll.set(website);
    dataAll.setLoadedSuccessfully(true);
  }
  else {
    dataAll.setLoadedSuccessfully(false);
    throw createError({ statusCode: 404, statusMessage: 'Website not found for hostname: ' + hostname })
  }
});